import { LoadingIndicator } from '@components';
import { UserPermisssions } from '@constants/common';
import { usePermissions } from '@hooks';
import AccessDeniedPage from '@pages/AccessDeniedPage';
import { ReactElement } from 'react';

type PermissionRouteProps = {
  permission: UserPermisssions;
  children: ReactElement;
};

const PermissionRoute = ({ permission, children }: PermissionRouteProps) => {
  const { hasPermission, permissionsLoaded } = usePermissions();

  if (!permissionsLoaded) return <LoadingIndicator />;
  if (!hasPermission(permission)) return <AccessDeniedPage />;
  return children;
};

export default PermissionRoute;
